import { useState } from 'react';

export const useZipcodeCoordinates = (latitude: number, longitude: number) => {
  const url = `https://dev.virtualearth.net/REST/v1/Locations/${latitude},${longitude}?o=xml&key=Ajkz_KnsjHxsfhRJeU78Xc8VgxAssv1iCF4leVVvmJLsPCaSXPaHdxuljT7aQ059`;
  const parser = new DOMParser();
  const [zipcode, setZipcode] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const fetchZipcode = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const resp = await fetch(url);
      const xmlText = await resp.text();
      const respXML = parser.parseFromString(xmlText, 'text/xml');
      let currentPostal =
        respXML.getElementsByTagName('PostalCode')[0].innerHTML;
      if (currentPostal.indexOf('-') !== -1) {
        currentPostal = currentPostal.split('-')[0];
      }
      setZipcode(currentPostal);
      setError(null);
    } catch (e) {
      setZipcode(null);
      setError('Error');
    }
    setIsLoading(false);
  };

  return { zipcode, error, isLoading, fetchZipcode };
};
